import React from 'react';
import { ConsultFormV2 } from '@milanlaser/mlcomponents';
import type { ConsultFormV2Props } from '@milanlaser/mlcomponents';
import { useCloudampDataRef } from '../../../../hooks/useCloudampData';
import './BrandPartner.styles.css';

const LINK_CLASSES = 'text-decoration-underline fw-bold';

function LegalLink({ href, children }: { href: string; children: React.ReactNode }) {
    return (
        <a href={href} target="_blank" rel="noreferrer" className={LINK_CLASSES}>
            {children}
        </a>
    );
}

// Separate from ConsentMsg on purpose (WEBDEV-4502). Same wording as Smooth's ConsentDisclosure
// and the local sites' OptInConsentMsg.
function ConsentDisclosure({ buttonText }: { buttonText: string }) {
    return (
        <p className="brand-partner-consent mcl-text-xs mcl-text-[#454545] mcl-font-proxima pb-0 mb-0">
            <small>
                By clicking {buttonText} <sup>**</sup>, I agree to the{' '}
                <LegalLink href="https://milanlaser.com/privacy">Privacy Policy</LegalLink>,{' '}
                <LegalLink href="https://milanlaser.com/terms">Mobile Terms</LegalLink>, and{' '}
                <LegalLink href="https://milanlaser.com/terms">Terms of Service</LegalLink> and consent to recurring
                promotional and service-related calls, emails, and texts from Milan Laser (including short code 64526,
                AI or automated texts). Consent to contact is not a purchase condition. Frequency varies. Msg&amp;data
                rates may apply. STOP to end. HELP for help.{' '}
                <a href="tel:+18336672967" className={`${LINK_CLASSES} text-nowrap`}>
                    1-833-667-2967
                </a>{' '}
                or email{' '}
                <a href="mailto:privacy@milanlaser.com" className={LINK_CLASSES}>
                    privacy@milanlaser.com
                </a>{' '}
                for support.
            </small>
            <br />
            **Exclusions apply. See store for details.
        </p>
    );
}

const renderConsentDisclosure = (buttonText: string) => <ConsentDisclosure buttonText={buttonText} />;

function BrandPartnerForm({ props }: { props?: ConsultFormV2Props }) {
    const cloudampDataRef = useCloudampDataRef();

    return (
        <ConsultFormV2
            {...props}
            className={`brand-partner-form ${props?.className ?? ''}`.trim()}
            cloudampRef={cloudampDataRef}
            showSmsOptIn={false}
            renderAdditionalCopy={renderConsentDisclosure}
        />
    );
}
export default BrandPartnerForm;
